import React from 'react'
import './Team.css'

function Team() {
    return (
        <>
            <div className='team'>
                <div className='team__container'>
                    <div className='team__wrapper'>
                        <h4 className='team__title'>About us</h4>
                        <p className='aboutus__info'>
                        Urban spatial informatics lab (USIL) at <a href='https://www.design.upenn.edu/' className='intro__link'> Department of City and Regional Planning, School of Design, University of Pennsylvania</a> aims to combine <strong>Science</strong>, <strong>Data</strong>, 
                        and <strong> Design</strong> together to tackle the pressing urban challenges through the collaboration with communities. We apply and develop AI, Geospatial Data Science, 
                        Environmental Modeling, High-performance Computing, Socio-environmental analyses to better understand the dynamics of urban socio-enviornment system and make our cities
                        more livable, sustainable, equitable, and healthy. 
                        </p>

                        <br></br>
                        <h4 className='team__title'>Faculty</h4>

                        <div className='team__item team__item--featured'>
                            <h5 className='team__subtitle'>Xiaojiang Li, Assistant Professor of Urban Spatial Analytics and Geospatial Data Science, Email: jianglix@design.upenn.edu</h5>

                            <div className='team__profile'>
                                <img
                                    className='team__item__img'
                                    loading='lazy'
                                    decoding='async'
                                    alt='Xiaojiang Li'
                                    src={'images/team/li.jpeg'}
                                />
                                <div className='bio__info'>
                                    Xiaojiang is a tenure-track assistant professor at Department of City and Regional Planning, University of Pennsylvania. He is also the co-founder 
                                    of <a className='link__bio' href="https://www.biometeors.com/" target="_blank" rel="noopener noreferrer">Biometeors</a>.
                                    He was an assistant professor at Department of Geography and Urban Studies, Temple University. 
                                    He was a Postdoctoral Fellow at MIT Senseable City Lab. He has been selected as the 50 Rising Stars in Geospatial World. He has been awarded the Global Young
                                    Scientist Award, World Geospatial Developers Conference. His research focuses on developing and applying geospatial analyses
                                    and data-driven approaches in the domain of urban studies. He has proposed to use Google Street View for urban environmental 
                                    studies and developed the Treepedia project, which aims to map street greenery for cities around the world. He is working
                                     on <a className='link__bio' href="https://xiaojianggis.github.io/heatexpo/" target='_blank' rel='noopener noreferrer'>HeatExpo</a> using artificial intelligence, remote sensing, urban microclimate modeling, and urban analytics to investigate
                                        the different vulnerabilities to climate change across different neighborhoods in the U.S. He is also working on using human 
                                        trace data to study human activities and investigate the connection between urban environments and human activities. 
                                        His research interests include Urban Science, Spatial Data Science, data-driven urban environment modeling, mobility
                                        and travel behavior profiling, urban computing and spatial analyses, and remote sensing. His research aims to provide a better understanding of human and urban environment systems and explore using digital technologies to benefit human society. His work has been featured in popular media outlets, including TIME, Wall Street Journal, Scientific American, The Guardian, Forbes, Atlantic-Citylab, Associated Press, and MIT News.
                                </div>                          
                            </div>
                        </div>
                    </div>


                    <div className='team__wrapper'>
                        <h4 className='team__title'>PhD Students</h4>

                        <div className='team__grid'>
                            <div className='team__item'>
                                <img className='team__item__img'
                                    loading='lazy'
                                    decoding='async' src='images/team/newman.png' alt='Elizabeth Newnam' />
                                <h5 className='team__subtitle'>Elizabeth Newnam</h5>

                                <div className='team__item__info'>
                                    Elizabeth is a Geography and Urban Studies PhD student at Temple University. Their research interests include quantitative geographic methodologies such as remote sensing, geographic information science, and python programming for geographic analysis, as well as sustainability, political ecology, and human-nature dynamics in the urban space.
                                </div>
                            </div>

                            <div className='team__item'>
                                <img className='team__item__img'
                                    loading='lazy'
                                    decoding='async' src='images/team/yi.jpeg' alt='Shengao Yi' />
                                <h5 className='team__subtitle'>
                                    <a className='link__team' href='https://shengaoyi.github.io/' target='_blank' rel='noopener noreferrer'>Shengao Yi</a>
                                </h5>

                                <div className='team__item__info'>
                                    Shengao (Eric) is a PhD student of at Department of City and Regional Planning, University of Pennsylvania.
                                    He finished his master degree at the University of Pennsylvania. His research interests
                                    include Geospatial Artificial Intelligence and Urban Analysis.
                                </div>
                            </div>

                            <div className='team__item'>
                                <img className='team__item__img'
                                    loading='lazy'
                                    decoding='async' src='images/team/deng.png' alt='Zimu Deng' />
                                <h5 className='team__subtitle'>Zimu Deng (Mark)</h5>

                                <div className='team__item__info'>
                                    Mark is a PhD student of Department of City and Regional Planning. He graduated from MUSA, University of Pennsylvania.
                                    He got his bachelor's degree in architecture at the University of Nottingham. His research interests include Urban AI technology, urban
                                    sustainability, resilience and public health towards climate change, urban micro-climate modeling, urban morphology optimization,
                                    and urban spatial analysis.
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="team__wrapper">
                        <h4 className="team__title">Master Students</h4>

                        <div className="team__grid">

                            <div className="team__item">
                                <img className='team__item__img' loading='lazy' decoding='async' src="images/team/zilai-xiong.jpg" alt="Zilai Xiong" />
                                <h5 className="team__subtitle">Zilai Xiong</h5>

                                <div className="team__item__info">
                                    Zilai is a student of Master of Science in Design: Environmental Building Design (MSD-EBD) candidate at the Weitzman School of Design, University of Pennsylvania. He holds a Bachelor of Engineering in Urban and Rural Planning from Shanghai University. His research focuses on urban building energy modeling (UBEM), urban microclimate simulation, and high-resolution spatial performance analytics.
                                </div>
                            </div>


                            <div className="team__item">
                                <img className='team__item__img' loading='lazy' decoding='async' src="images/team/qiwen-bian.jpg" alt="Qiwen Bian" />
                                <h5 className="team__subtitle">Qiwen Bian</h5>

                                <div className="team__item__info">
                                    Qiwen is a Master of Urban Spatial Analytics (MUSA) student at the Department of City and Regional Planning, University of Pennsylvania. She received his B.Eng. in Urban Planning from Zhejiang University. Her research interests include spatial intelligence and spatiotemporal data mining for social sensing.                                
                                </div>
                            </div>

                        </div>

                    </div>

                    <div className="team__wrapper">
                        <h4 className="team__title">High School Students</h4>

                        <div className="team__grid">
                            <div className="team__item">

                                <img className='team__item__img' loading='lazy' decoding='async' src="images/team/lewen.jpg" alt="Lewen Feng" />
                                <h5 className="team__subtitle">Lewen Feng</h5>

                                <div className="team__item__info">
                                    Lewen is a senior at Cranbrook Kingswood Upper School in Michigan. He loves to code 
                                    and explore ways to utilize geospatial technology to solve everyday challenges 
                                    such as sun glare for drivers, and tree planting 
                                    for heat mitigation. His interests also include social impact, urban computing, 
                                    and policy recommendations.                                
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="team__wrapper">
                        <h4 className="team__title">Alumni</h4>

                        <div className="team__grid">
                            <div className="team__item">

                                <img className='team__item__img' loading='lazy' decoding='async' src="images/team/abdul.jpeg" alt="Lewen Feng" />
                                <h5 className="team__subtitle">Lewen Feng</h5>

                                <div className="team__item__info">
                                    Abdul is a Social Policy and Data Analytics Master’s student at University of Pennsylvania on a Fulbright, focusing on geospatial applications in social policy.
                           
                                </div>
                            </div>

                            <div className="team__item">
                                <img className='team__item__img' loading='lazy' decoding='async' src="images/team/frankchen.png" alt="Frank Chen" />
                                <h5 className="team__subtitle">Frank Chen</h5>

                                <div className="team__item__info">
                                    Frank is a Master of City Planning student at the Department of City and Regional Planning, University of Pennsylvania.
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Team

